import React from 'react';
import classNames from 'classnames';
import { ReactComponent as WarningInfoIcon } from '../../assets/icons/warningInfo.svg';
import css from './WarningBox.module.css';

const WarningBox = (props) => {
    const { title, content, className } = props;
    return <div className={classNames(css.root, className)}>
        <h4 className={css.title}>
            <WarningInfoIcon />
            <span>{title}</span>
        </h4>
        <div className={css.content}>
            {content}
        </div>
    </div>
};

export default WarningBox;
